import baseAPI from '@/http'

const router = 'api/seloClienteOcultoPerguntas'

export const seloClienteOcultoPerguntasAPI = {

  getPerguntas: () => baseAPI.get(`${router}/obter-cliente-oculto-perguntas`),
  getSituacaoDiagnostico: (municipioId) => baseAPI.get(`${router}/obter-situacao-cliente-oculto/${municipioId}`),

}
